import React, { useState, useEffect } from "react";
import { TextField, InputAdornment, Box, Tooltip } from "@material-ui/core";
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import {Autocomplete} from '@material-ui/lab';
import useStyles from './styles'
import ttAPI from '../../api/ttAPI'


export default function SelectCustomer(props) {
  const { onFormUpdated, onSelect, selectedCustomer, labelName, disabled } = props
  const classes = useStyles();
  const [customerSearchedList, setCustomerSearchedList] = useState([]);
  const [selectedCustomerValue, setSelectedCustomerValue] = useState({});
  const [customerInputValue, setCustomerInputValue] = useState('');
  const [isSearchCustomerOpen, setIsSearchCustomerOpen] = useState(false);

  useEffect( () => {
    async function fetchData() {
      var response;
      if (customerInputValue === undefined || customerInputValue === null ||
          customerInputValue === '') {
          response = await ttAPI.getFirstFewActiveCustomers(50);


      }
      else {
          response = await ttAPI.getCustomersByKey(customerInputValue);
          setCustomerSearchedList(response);
      }
      setCustomerSearchedList(response);

    }
  //if (customerInputValue !== undefined && customerInputValue !== '') {
      fetchData();
    //}
  }, [customerInputValue]);

  useEffect(() => {
    if (!isSearchCustomerOpen) {
      setCustomerSearchedList([]);
    }
  }, [isSearchCustomerOpen]);

  useEffect(() => {
    if (selectedCustomer === undefined || selectedCustomer === null) {
      setSelectedCustomerValue({});
      setCustomerSearchedList([]);
      setCustomerInputValue('');
    }
    else {
      setSelectedCustomerValue(selectedCustomer);
      setCustomerSearchedList([selectedCustomer]);
      setCustomerInputValue(selectedCustomer.name);
      onSelect(selectedCustomer);
      onFormUpdated(true);
    }

  }, [selectedCustomer]);

   // note: for getOptionSelected: if you return false for no match then there will be a warning in the console complain the input does not match what's in the options}
  return (
<div className={classes.contentDiv}>
    {/*}<div>{`selectedCustomerValue: ${selectedCustomerValue !== undefined && selectedCustomerValue !== null ? `'${selectedCustomerValue.name}'` : 'null'}`}</div>
    <div>{`selected id: ${selectedCustomerValue !== undefined && selectedCustomerValue !== null ? `'${selectedCustomerValue.id}'` : 'null'}`}</div>
    <div>{`customerInputValue: '${customerInputValue}'`}</div>*/}
    <div></div>


    <Autocomplete
      disabled={disabled ?? false}
      id="search-customer"
      className={classes.autocomplete}
      getOptionSelected={(option, value) => {return Object.keys(option).length === 0 || Object.keys(value).length === 0 ? true : option.name === value.name;}}
      getOptionLabel={(option) => Object.keys(option).length === 0 ? '' : option.name}
      options={customerSearchedList}
      noOptionsText="Type to search"
      onChange={(event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
          setSelectedCustomerValue(newValue);
          onSelect(newValue);
          onFormUpdated(true);
        }
        else {
          setSelectedCustomerValue({});
          onSelect(undefined);
          onFormUpdated(false);
        }
      }}
      open={isSearchCustomerOpen}
      onOpen={() => {
        setIsSearchCustomerOpen(true);
        if (customerSearchedList !== undefined && customerSearchedList !== null &&
            customerSearchedList.length === 0 && (customerSearchedList === undefined ||
            customerInputValue !== null || customerInputValue === '')) {
            setCustomerInputValue(' ');
        }
      }}
      onClose={() => {
        setIsSearchCustomerOpen(false);
      }}
      inputValue={customerInputValue}
      value={selectedCustomerValue}
      onInputChange={(event, newInputValue,reason) => {
          setCustomerInputValue(newInputValue);
      }}
      size="small"
      renderInput={(params) => (
              <TextField
                {...params}
                label={labelName}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      {selectedCustomerValue?.key_customer && (
                        <Tooltip title="Key customer">
                          <InputAdornment position="start">
                            <VpnKeyIcon style={{ fontSize: 18, color: '#d4a017' }} />
                          </InputAdornment>
                        </Tooltip>
                      )}
                      {selectedCustomerValue?.kpi_customer && (
                        <Tooltip title="KPI customer">
                          <InputAdornment position="start">
                            <TrackChangesIcon style={{ fontSize: 18, color: '#d4a017' }} />
                          </InputAdornment>
                        </Tooltip>
                      )}
                      {params.InputProps.startAdornment}
                    </>
                  ),
                }}
              />
            )}
      renderOption={(option) => (
                            <Box display="flex" alignItems="center" gridGap={6}>
                              {option.key_customer && (
                                <Tooltip title="Key customer">
                                  <VpnKeyIcon style={{ fontSize: 18, color: '#d4a017' }} />
                                </Tooltip>
                              )}
                              {option.kpi_customer && (
                                <Tooltip title="KPI customer">
                                  <TrackChangesIcon style={{ fontSize: 18, color: '#1976d2' }} />
                                </Tooltip>
                              )}
                              <span>{option.name}</span>
                            </Box>
                          )}
      />
      </div>
  );
}
